import './styles.scss'
import React from 'react'

export default function DesktopPopularActivities ({ activities }) {
  return (
    <div className='grid-all'>
      <div className='activities-container'>
        {activities.map(({ id, categoryTitle, subCategories }) => {
          return (
            <div className='category' key={id} style={{ marginRight: activities.length <= 3 ? 40 : 0 }}>
              <p className='category-title'>{categoryTitle}</p>
              <ul>
                {subCategories.map(({ title, id, url }) => (
                  <li key={id}>
                    <a href={url} className='sub-category'>
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}
      </div>
    </div>
  )
}
